var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircleFilled = function SvgCloseCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.625.007 12 0m4 14.587A1 1 0 1 1 14.587 16L12 13.414 9.414 16A1 1 0 0 1 8 14.586L10.586 12 8 9.414A1 1 0 0 1 9.414 8L12 10.586 14.587 8A1 1 0 1 1 16 9.413L13.414 12z"
  })));
};
export default SvgCloseCircleFilled;